import { SVGProps, Ref, forwardRef } from 'react';

export const DashedSquareInOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path d="M15 4.6h-3.6V1H10v5h5z" fill="currentColor" />
                <path d="M1 4.6V6h5V1H4.6v3.6z" fill="currentColor" />
                <path d="M4.6 15H6v-5H1v1.4h3.6z" fill="currentColor" />
                <path d="M15 11.4V10h-5v5h1.4v-3.6z" fill="currentColor" />
            </g>
        </svg>
    )
);
DashedSquareInOutlinedSize16Glyph.displayName = 'DashedSquareInOutlinedSize16Glyph';
